import Glide, { Autoplay, Swipe, Controls } from '@glidejs/glide/dist/glide.modular.esm';

document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector('.glide')) {
        const banner = document.querySelector('.glide');
        const pauseOnHover = Boolean(banner.dataset.pauseOnHover);

        let glide = new Glide(banner, {
            autoplay: 5000,
            perView: 1,
        }).mount({ Autoplay, Swipe, Controls });

        if (pauseOnHover) {
            const slide = document.querySelector('.banner');

            slide.addEventListener('mouseenter', () => {
                glide.pause();
                //slide.classList.add('paused');
            });

            slide.addEventListener('mouseleave', () => {
                glide.play();
                //slide.classList.remove('paused');
            });
        }

        // Background image switching based on screen size
        const slides = document.querySelectorAll('.glide__slide.slide-image');

        slides.forEach(slide => {
            const mobileImage = slide.getAttribute('data-mobile-image');
            const desktopImage = slide.getAttribute('data-desktop-image');
            function setBackgroundImage() {
                if (window.innerWidth < 768) {
                    if(mobileImage) {
                        slide.style.backgroundImage = `url(${mobileImage})`;
                    }
                } else {
                    if(desktopImage)
                        {
                            slide.style.backgroundImage = `url(${desktopImage})`;
                        }
                }
            }

            setBackgroundImage();

            window.addEventListener('resize', setBackgroundImage);
        });
    }
});
